import DateInput from './src/DateInput.vue';

DateInput.install = function(Vue) {
  Vue.component(DateInput.name, DateInput);
};

export default DateInput;
